import { TableHead } from '@/components/Datatable/TableHead';
import { TableHeadersProps } from '@/type/listing.types';

export const VehiculeCheckEmailTableHeaders = ({ t }: TableHeadersProps) => {
  return (
    <>
      <TableHead text={t('common:date')} sortable thClassName="w-[170px]" />
      <TableHead text={t('common:sender')} sortable thClassName="w-[270px]" />
      <TableHead text={t('common:emailSubject')} sortable />
      <TableHead thClassName="sticky-action-column" />
    </>
  );
};
